import { ofType } from 'redux-observable';
import { map, mergeMap } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { ActionManagerInstance } from '../../actions/manager';
import { postProcessOpenActionRequest } from '../open-action-helper';
import { isErrorActionType } from '../common-helper';
import { processDataToDispatchErrorAction } from '../../store/state/epics/util';
import Utils from '../../utils/utils';
import * as StateManager from '../../store/state/state-manager';
import type { Action } from '../../store/state/state-manager';

import { processOpenBulkActionRequest, processCallBacks } from './helper';
import { OPEN_BULK_ACTION } from './action-creator';

// Todo : Enhance after integrating with actual dxapi
const openBulkAction = (action$: Observable<Action>) => {
  let actionMgrID = 0;
  let actionsOut: any[] = [];

  return action$.pipe(
    ofType(OPEN_BULK_ACTION),
    map((action: Action) => {
      ({ actionMgrID } = action.payload);
      return action.payload;
    }),
    mergeMap((actionInPayload) => {
      return processOpenBulkActionRequest(actionInPayload, { actionMgrID });
    }),
    mergeMap(async (chainedData) => {
      if (chainedData && isErrorActionType(chainedData.type)) {
        const errorAction = processDataToDispatchErrorAction(chainedData);
        actionsOut.push(errorAction);
        return actionsOut;
      }

      const { actionInPayload, headers, response } = chainedData;
      const { actionID } = actionInPayload;

      Utils.setIn(response, 'data.caseInfo.activeActionID', actionID);

      await postProcessOpenActionRequest(response, actionsOut, { headers, actionInPayload });
      processCallBacks(actionInPayload);
      return actionsOut;
    }),
    map(() => {
      if (actionsOut.length === 1 && isErrorActionType(actionsOut[0].type)) {
        ActionManagerInstance.rejectActionByID(actionMgrID);
      } else {
        ActionManagerInstance.resolveActionByID(actionMgrID);
      }
      StateManager.dispatch(actionsOut);
      actionsOut = [];
      return actionsOut;
    })
  );
};

export default openBulkAction;
